import React, { forwardRef }    from 'react';
import PropTypes                from 'prop-types';
import classNames               from 'classnames';

import Icons                    from '../../../../../assets/svg/icons.js';

import styles                   from './ServicesBlock.styl';

function ServiceBlock(props, ref) {
    // const {  } = props;

    // const {} = useMessage();

    return  (
        <section
            className = {styles.ServicesBlock}
            ref = {ref}
        >
            <div className={styles.blockName}>
                <span className={styles.dot} />
                Featured services
            </div>
            <h2 className={styles.blockTitle}>
                Why will you choose Roimax?
            </h2>
            <h3 className={styles.description}>
                It’s easy to make good choices when you have good insights
            </h3>
            <div className={styles.services}>
                <div className={styles.service}>
                    <div className={classNames(styles.iconWrapper, styles.marketing)}>
                        <Icons.Marketing />
                    </div>
                    <div className={styles.serviceTitle}>
                        Advanced Marketing Analytics
                    </div>
                    <div className={styles.serviceDescription}>
                    Analytics technologies on our open platform can help you to choose the best options for your business and customers needs
                    </div>
                </div>
                <div className={styles.service}>
                    <div className={classNames(styles.iconWrapper, styles.automation)}>
                        <Icons.Automation />
                    </div>
                    <div className={styles.serviceTitle}>
                        Advanced UA Automation
                    </div>
                    <div className={styles.serviceDescription}>
                        When it comes to marketing, you should only pay for what works. Our automation platform provides cutting-edge technology.
                    </div>
                </div>
                <div className={styles.service}>
                    <div className={classNames(styles.iconWrapper, styles.setup)}>
                        <Icons.Box />
                    </div>
                    <div className={styles.serviceTitle}>
                        No SDK Needed. 15 minutes setup
                    </div>
                    <div className={styles.serviceDescription}>
                        Connect your MMP and Media Sources in minutes. Start Automation right now.
                    </div>
                </div>
                <div className={styles.service}>
                    <div className={classNames(styles.iconWrapper, styles.simulations)}>
                        <Icons.Simulations />
                    </div>
                    <div className={styles.serviceTitle}>
                        Automation Simulations
                    </div>
                    <div className={styles.serviceDescription}>
                        Test automation without risks.
                    </div>
                </div>
            </div>
        </section>
    );
}

ServiceBlock.propTypes = {
    className : PropTypes.string,
    message   : PropTypes.string
};

ServiceBlock.defaultProps = {
    className : '',
    message   : ''
};

export default forwardRef(ServiceBlock);
